var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container p-4" }, [
    _vm.preQrPayment !== null
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6 offset-lg-3" }, [
            _vm.preQrPayment && !_vm.preQrPayment.paid_status
              ? _c("div", [
                  _vm.isExpiredPayment()
                    ? _c("div", { staticClass: "text-center" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "pb-3" }, [
                          _vm._v(
                            "ไม่สามารถดำเนินการชำระเงินได้ เนื่องจากเลยระยะเวลาการทำรายการ\n            กรุณาติดต่อแอดมินเพื่อช่วยประสานงาน\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-info btn-block",
                            attrs: {
                              href: "https://line.me/R/ti/p/%40hnk7011n",
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("message.button.contact_admin"))
                            )
                          ]
                        )
                      ])
                    : _c(
                        "div",
                        [
                          _c("div", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n            กรุณาดำเนินการชำระเงินภายใน " +
                                _vm._s(_vm._f("prettyDate")(_vm.paymentDate)) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("qr-code-payment", {
                            ref: "qrCodePayment",
                            on: { checkQrPayment: _vm.checkQrPayment }
                          })
                        ],
                        1
                      )
                ])
              : _c("div", { staticClass: "text-center" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      _vm._s(_vm.$t("message.qr_payment.payment_successful"))
                    )
                  ])
                ])
          ])
        ])
      : _c("div", { staticClass: "text-center" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3)
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center pb-3" }, [
      _c("i", { staticClass: "fal fa-times-circle text-danger fa-3x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-4" }, [
      _c("i", { staticClass: "fas fa-check-circle fa-5x -status-accepted" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-4" }, [
      _c("i", { staticClass: "fas fa-times-circle fa-5x -status-alert" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("ไม่สามารถดำเนินการชำระเงินได้"),
      _c("br"),
      _vm._v("เนื่องจากไม่มีข้อมูลธุรกรรมในระบบ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11c93ac8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c93ac8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qrPayment/PreQrPayment.vue
// module id = 2273
// module chunks = 0